import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";
import { rupees } from "../../helper";
import { BgLoader, TableZero, PageError } from "../../ui";
import { useNavigate, useOutletContext } from "react-router-dom";

import { Link, useLocation } from "react-router-dom"

import { Helmet } from "react-helmet";


export default function Ledger() {
  let navigate = useNavigate();
  const [state, setState] = useState({});
  const [loader, showLoader] = useState({});

  const [pstate, setTitle] = useOutletContext(); // <-- access context value





  const fetchData = () => {
    instance
      .get("/cust_ledger")
      .then(function (response) {

        setState({ ...state, ...response.data });

      })
      .catch(function (error) { })
      .then(function () { });

  }


  useEffect(() => {
    setTitle('Ledger')
    fetchData()
  }, []);


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }
  if (pstate.company.ledger == 0) {
    return (
      <PageError msg='Access denied!' />
    )
  }



  return (
    <div>
      <Helmet>
        <title>Ledger</title>
        {pstate.company && pstate.company.logo  &&  <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>
      {state.items && state.items.length > 0 ? (
         <>

         <div className="pt-2">


           <table className="table table-striped">
             <thead>
               <tr>
                 <th>Date</th>
                 <th>Particulars</th>
                 <th>Debit</th>
                 <th>Credit</th>
                 <th>Balance</th>
               </tr>
             </thead>
             <tbody>

             {state.items.map((adata, index) => (
               <tr key={index}>
                 <td>
                   {adata.date}
                 </td>
                 <td>
                 <span className="me-1">{adata.type}</span> {adata.type =='Invoice' ? <Link to={`/invoice/${adata.id}`}> #{adata.invoice_id}</Link> : adata.type == 'Credit Note' ? <Link to={`/credit-note/${adata.id}`}> #{adata.cn_id}</Link> : adata.type == 'Receipt' ? <Link to={`/receipt/${adata.id}`}> #{adata.receipt_id}</Link> : '' }
                 </td>
                 <td>
                   {rupees(adata.debit)}
                 </td>
                 <td>
                   {rupees(adata.credit)}
                 </td>
                 <td>
                   {rupees(adata.balance)}
                 </td>
               </tr>
             ))}
             </tbody>
           </table>
           
         </div>
       </>
      ) : state.items && state.items.length == 0 ? <TableZero title="Entries"/> : (
        <BgLoader />
      )}
    </div>
  );
}
